import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ImageUrl } from '../../utils/constants';
import { NotificationIcon, LaunchIcon, UnArchivedIcon, NewWarningIcon } from '../../utils/icons';
import { ActiveInitiativeCardWrapper } from './styles';
import { CommonButtonPopup } from '../HealthCoach/styles';
import CircularProgressBar from '../common/CircularProgressBar/CircularProgressBar';
import dayjs from 'dayjs';
import CommonModalNew from '../common/CommonModal/CommonModalNew';
import { fetchApi } from '../../utils/methods';
import { UnarchivedInitiative } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';

const ActiveInitiativeCard = ({ details, isArchived , isArchivedButton, fetchArchivedInitiatives,   onBellClick, onLaunchClick, onCardClick, hideBell, fullWidth }) => {
  const [contentHover, setContentHover] = useState(false);
  const isLaunched = !!details?.launch_date || !!details?.start_date;
  const [openArchivedPopup, setOpenArchivedPopup] = useState(false);

  const daysLeft = details?.end_date
    ? Math.ceil((new Date(details.end_date) - new Date()) / (1000 * 60 * 60 * 24))
    : null;



  const handleArchive = async () => {
    try {
      const res = await fetchApi(UnarchivedInitiative, 'POST', {
        company_initiative_id: details?.company_initiative_id,
      });
      if (res.status === 'success') {
        toast.success('Initiative Unarchived successfully');
        // refresh archived data also
        fetchArchivedInitiatives && fetchArchivedInitiatives();

      } else {
        toast.error(res.message || 'Failed to unarchive initiative');
      }
    } catch (err) {
      toast.error(err.message);
    }
    setOpenArchivedPopup(false);
  };


  const isCompleted = daysLeft !== null && daysLeft <= 0;

  return (
    <ActiveInitiativeCardWrapper isPadding={isArchived  ? "24px 2px 16px 16px" : "24px 16px 16px 16px" } borderColor={details?.font_color} color={details?.color} fullWidth={fullWidth}>
      <div className="card-header">
        <div className="icon-wrap">
          <img src={`${ImageUrl}/${details?.initiative_white_icon}`} alt="" />
        </div>
        <div className="name" title={details?.initiative_name}>{details?.initiative_name}</div>
        {(!hideBell && !isCompleted) && (
          <div className="bell-wrap" onClick={() => onBellClick && onBellClick(details)}>
            <NotificationIcon />
          </div>
        )}
        {isArchivedButton && <div className="archived-label" onClick={()=> setOpenArchivedPopup(true) }>{UnArchivedIcon()}</div>}
      </div>
      {details?.initiative_type && (
        <span className="type-badge">{details.initiative_type}</span>
      )}
      <div style={{ height: '0.75px', background: '#DCDCDC', margin: '12px 0' }} />

      {isLaunched ? (
        <>
          <div
            className="content-row"
            style={{ position: 'relative' }}
            onMouseEnter={() => setContentHover(true)}
            onMouseLeave={() => setContentHover(false)}
          >
            <div className="progress-wrap">
              <CircularProgressBar
                percentage={details?.user_initiative_taken_percentage || details?.percentage || 0}
                color={'#75B084'}
                innerCircle={"#2F6C42"}
                size={150}
                strokeWidth={12}
                outerStroke={"#75B084"}
              />
            </div>
            <div className="stats">
              <div className="stat-row">
                <span className="label">Users Completed</span>
                <span className="colon">:</span>
                <span className="val">{details?.total_participation || 0}</span>
              </div>
              <div className="stat-row">
                <span className="label">Users Invited</span>
                <span className="colon">:</span>
                <span className="val">{details?.user_count ?? 0}</span>
              </div>
              {/* {daysLeft !== null && (
                <div className="stat-row">
                  <span className="label">Ends In</span>
                  <span className="colon">:</span>
                  <span className="val">{daysLeft > 0 ? `${daysLeft} Days` : 'Completed'}</span>
                </div>
              )} */}

              {daysLeft !== null && (
                <div className="stat-row">
                  <span className="label">
                    {isArchived ? "Archived On" : isCompleted? "Ended On": "Ends In"}
                  </span>
                  <span className="colon">:</span>
                  <span className="val">
                    {isArchived ? dayjs(details?.archived_at).format('MMM DD, YYYY') : isCompleted
                      ? dayjs(details?.end_date).format('MMM DD, YYYY')
                      : `${daysLeft} Days`}
                  </span>
                </div>
              )}
            </div>
            {contentHover && onCardClick && (
              <div style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.6)',
                borderRadius: '0 0 8px 8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                zIndex: 3,
              }}>
                <CommonButtonPopup
                  width="160px"
                  background="#DA6C74"
                  style={{ justifyContent: 'center' }}
                  onClick={() => onCardClick(details)}
                >
                  View Details
                </CommonButtonPopup>
              </div>
            )}
          </div>
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <CommonButtonPopup
            width="200px"
            background="#DA6C74"
            onClick={() => onLaunchClick && onLaunchClick(details)}
          >
            <LaunchIcon />
            Launch Initiative
          </CommonButtonPopup>
        </div>
      )}

      {openArchivedPopup && (
        <CommonModalNew
          show={openArchivedPopup}
          modalWidth={"400px"}
          title="Unarchive Initiative"
          description="Are you sure you want to Unarchive this initiative?"
          subDescription="This initiative will be moved out of the Archived tab. If its end date hasn't passed, it will appear in the Active tab and be visible to users. If the end date has already passed, it will move to the Completed tab."
          onCancel={() => setOpenArchivedPopup(false)}
          descriptionColor="#CE7841"
          onConfirm={handleArchive}
          cancelText="Keep archive"
          confirmButtonText="Unarchive Initiative"
          icon={NewWarningIcon('#CE7841')}
          cancelButtonWidth={"150px"}
          confirmButtonWidth={"180px"}
          buttonIcon={<></>}
        />
      )}
    </ActiveInitiativeCardWrapper>
  );
};

ActiveInitiativeCard.propTypes = {
  details: PropTypes.object,
  onBellClick: PropTypes.func,
  onLaunchClick: PropTypes.func,
  onCardClick: PropTypes.func,
  hideBell: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isArchived: PropTypes.bool,
  isArchivedButton: PropTypes.bool,
  fetchArchivedInitiatives: PropTypes.func,
};

export default ActiveInitiativeCard;
